// action - state management
import { LOGIN, LOGOUT, REGISTER, UPDATE_USER } from './actions';
import mixpanel from 'mixpanel-browser';

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
    isLoggedIn: false,
    isInitialized: false,
    user: null
};

// eslint-disable-next-line
const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case REGISTER: {
            const { user } = action.payload;
            mixpanel.identify(user?.id);

            return {
                ...state,
                user
            };
        }
        case LOGIN: {
            const { user } = action.payload;
            mixpanel.identify(user?.id);

            return {
                ...state,
                isLoggedIn: true,
                isInitialized: true,
                user
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isInitialized: true,
                isLoggedIn: false,
                user: null
            };
        }
        case UPDATE_USER: {
            const { user } = action.payload;
            return {
                ...state,
                user
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
